import { get } from 'lodash';
import PropTypes from 'prop-types';
import { getPrice } from '../../../../../common/routines/utils';
import { ADDENDUM_IN_PROGRESS } from '../../../../../constants/reports';
import { formatDate } from '../../../../../utils/formatters';

const InterestAndFinancebyCustomerReportTableRow = ({ rowData, id, dynamicHeaders }) => {
  const { purchaserName, onePortalId, service } = rowData;
  const getData = (headerName, item, type) => {
    let amount;
    let month;
    Object.keys(item?.timePeriods).forEach((subItem) => {
      if (subItem === headerName) {
        amount =
          type?.type === 1
            ? get(item?.timePeriods, subItem)?.principle
            : get(item?.timePeriods, subItem)?.interest;
        month = subItem;
      }
    });
    return <td>{month ? getPrice(amount) : 'NA'}</td>;
  };
  return (
    <>
      {service?.map((item) => (
        <>
          <tr key={id}>
            <td rowSpan={service?.length * 2}>{id}</td>
            <td rowSpan={service?.length * 2} className="purchase-td">
              <span>{purchaserName}</span>
              <span>{onePortalId}</span>
            </td>
            <td className="business-td">
              <span>{item?.serviceType}</span>
              <span> {item?.serviceNumber}</span>
              {item?.addendumStatus === ADDENDUM_IN_PROGRESS && (
                <span className="addendum-note">Note: Addendum In Progress</span>
              )}
              Principle
            </td>
            <td>{getPrice(item?.OpeningBalance?.principle)}</td>
            {dynamicHeaders?.map((headerName) => {
              return getData(headerName, item, { type: 1 });
            })}
            <td>{getPrice(item?.BalancePeriod?.principle)}</td>
            <td>{getPrice(item?.ClosingBalance?.principle)}</td>
            <td>{formatDate(item?.ClosingDate)}</td>
          </tr>
          <tr>
            <td>Interest</td>
            <td>{getPrice(item?.OpeningBalance?.interest)}</td>
            {dynamicHeaders?.map((headerName) => {
              return getData(headerName, item, { type: 2 });
            })}
            <td>{getPrice(item?.BalancePeriod?.interest)}</td>
            <td>{getPrice(item?.ClosingBalance?.interest)}</td>
            <td>{formatDate(item?.ClosingDate)}</td>
          </tr>
        </>
      ))}
    </>
  );
};

InterestAndFinancebyCustomerReportTableRow.propTypes = {
  rowData: PropTypes.shape({
    purchaserName: PropTypes.string,
    onePortalId: PropTypes.string,
    service: PropTypes.shape([
      {
        serviceType: PropTypes.string,
        serviceNumber: PropTypes.string,
        OpeningBalance: PropTypes.shape({
          principle: PropTypes.number,
          interest: PropTypes.number,
        }),
        BalancePeriod: PropTypes.shape({
          principle: PropTypes.number,
          interest: PropTypes.number,
        }),
        ClosingBalance: PropTypes.shape({
          principle: PropTypes.number,
          interest: PropTypes.number,
        }),
        ClosingDate: PropTypes.string,
        addendumStatus: PropTypes.string,
      },
    ]),
  }).isRequired,
  id: PropTypes.number.isRequired,
  dynamicHeaders: PropTypes.shape([]).isRequired,
};

export default InterestAndFinancebyCustomerReportTableRow;
